<template>
  <div>
    <svg 
      id="flow-map"
      ref="flow-map"
      :width="flowMapWidth"
      :height="flowMapHeight"
      class="top-left"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <g 
        v-for="(event, index) in filteredEvents" 
        :key="'flow-map-lines' + event.key"
        :class="[
          getEventType(event),
          {
            'passed': isPassed(event, activeEventNr),
            'active': isActive(event, activeEventNr)
          }
        ]"
        class="event">
        <line 
          v-if="index > 0"
          :x1="previousX(event)"
          :y1="previousY(event)"
          :x2="event.x * scale"
          :y2="event.y * scale"/>
      </g>

      <g 
        v-for="event in filteredEvents" 
        :key="'flow-map-icons' + event.key"
        :class="[
          getEventType(event),
          {
            'passed': isPassed(event, activeEventNr),
            'active': isActive(event, activeEventNr)
          }
        ]"
        class="event"
        @click.prevent="selectEvent(event)">
        <svg 
          :x="(event.x * scale) - 9"
          :y="(event.y * scale) - 9"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          class="map-icon click-icon"
          viewBox="0 0 14 14">
          <circle 
            cx="7" 
            cy="7" 
            r="6"/>
        </svg>
        <svg 
          :x="(event.x * scale) - 9"
          :y="(event.y * scale) - 9"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          class="map-icon d-click-icon"
          viewBox="0 0 15 15">
          <circle 
            class="cls-1" 
            cx="7" 
            cy="7" 
            r="6"/>
          <circle 
            cx="7" 
            cy="7" 
            r="3"/>
        </svg>
        <svg 
          :x="(event.x * scale) - 9"
          :y="(event.y * scale) - 9"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          class="map-icon drag-start-icon"
          viewBox="0 0 15.37 14.09">
          <polygon points="7.68 12 1.69 1 13.69 1 7.68 12"/>
        </svg>
        <svg 
          :x="(event.x * scale) - 9"
          :y="(event.y * scale) - 9"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          class="map-icon drag-end-icon"
          viewBox="0 0 15.37 14.09">
          <polygon points="7.68 2.09 13.69 13.09 1.69 13.09 7.68 2.09"/>
        </svg>
        <svg 
          :x="(event.x * scale) - 9"
          :y="(event.y * scale) - 9"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"

          class="map-icon key-icon"
          viewBox="0 0 13 13">
          <rect 
            x="1" 
            y="1" 
            width="11" 
            height="11"/>
          <text 
            x="4" 
            y="9.5">{{ nrOfEventsInPlace(event.x, event.y) }}</text>
        </svg>
        <svg 
          :x="(event.x * scale) - 9"
          :y="(event.y * scale) - 9"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          class="map-icon start-icon"
          viewBox="0 0 8.48 15.55">
          <polygon points="1.48 7.77 7.48 2.27 7.48 13.27 1.48 7.77"/>
        </svg>
        <svg 
          :x="(event.x * scale) - 9"
          :y="(event.y * scale) - 9"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          class="map-icon end-icon"
          viewBox="0 0 8.48 15.55">
          <polygon points="7 7.77 1 13.27 1 2.27 7 7.77"/>
        </svg>
      </g>
    </svg>
    <a 
      ref="snapshot-download"
      :download="snapshotName"
      href="#"
      class="hidden"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getEventType, isPassed, isActive } from '../lib/functions'

export default {
  name: 'FlowMap',
  data() {
    return {
      snapshotLoading: false,
    }
  },
  computed: {
    ...mapState(['viewPortWidth', 'viewPortHeight', 'scaleFactor']),
    ...mapGetters(['relativeWidth', 'relativeHeight', 'filteredEvents', 'activeEventNr', 'activeEvent']),
    flowMapWidth() {
      return this.snapshotLoading ? this.viewPortWidth : this.relativeWidth
    },
    flowMapHeight() {
      return this.snapshotLoading ? this.viewPortHeight : this.relativeHeight
    },
    scale() {
      return this.snapshotLoading ? 1 : this.scaleFactor
    },
    snapshotName() {
      const activeEventImg = this.activeEvent ? this.activeEvent.image : 'snapshot.jpg'
      const activeEventImgParts = activeEventImg.split('.')
      const activeEventImgName = activeEventImgParts[0]
      return activeEventImgName + '_flowmap.svg'
    },
  },
  mounted() {
    this.$eventBus.$on('take-snapshot', this.snapshot)
  },
  methods: {
    getEventType,
    isPassed,
    isActive,
    selectEvent(event) {
      const query = { ...this.$route.query }
      this.$router.push({ name: 'event', params: { eventNr: event.key }, query })
    },
    previousX(event) {
      const eventIndex = this.filteredEvents.indexOf(event)
      const previousEvent = this.filteredEvents[eventIndex - 1]
      return previousEvent.x * this.scale
    },
    previousY(event) {
      const eventIndex = this.filteredEvents.indexOf(event)
      const previousEvent = this.filteredEvents[eventIndex - 1]
      return previousEvent.y * this.scale
    },
    nrOfEventsInPlace(x, y) {
      return this.filteredEvents.filter(event => event.x === x && event.y === y).length
    },
    inlineStyles(el = {}) {
      const childNodes = el.childNodes || []

      childNodes.forEach(childEl => {
        if (childEl.nodeType !== Node.ELEMENT_NODE) {
          return
        }

        const computedStyles = getComputedStyle(childEl)
        childEl.setAttribute('stroke', computedStyles.getPropertyValue('stroke'))
        childEl.setAttribute('fill', computedStyles.getPropertyValue('fill'))
        childEl.setAttribute('visibility', computedStyles.getPropertyValue('visibility'))

        this.inlineStyles(childEl)
      })
    },
    snapshot() {
      const flowMap = this.$refs['flow-map']
      const snapShotDownloadEl = this.$refs['snapshot-download']

      if (flowMap && snapShotDownloadEl) {
        this.snapshotLoading = true

        this.$nextTick(() => {
          this.inlineStyles(flowMap)

          const url = 'data:image/svg+xml;utf-8,' + flowMap.outerHTML.replace(/\r?\n|\r/g, '')
          snapShotDownloadEl.href = url
          snapShotDownloadEl.click()

          this.snapshotLoading = false
        })
      }
    },
  },
}
</script>

<style lang="scss">
#flow-map {
  z-index: 99;

  .event line {
    stroke: #0073ff;
    stroke-width: 2px;
  }

  .event.passed line {
    stroke: #ff00a4;
    stroke-width: 4px;
  }

  .event.active line {
    stroke: #000;
    stroke-width: 6px;
  }

  .event.drag-end line,
  .event.scroll-end line {
    stroke-dasharray: 8, 4;
  }

  .event .map-icon {
    visibility: hidden;
    fill: #fff;
    cursor: pointer;
  }

  .event .map-icon {
    stroke: #0073ff;
    stroke-width: 2px;
  }

  .event.passed .map-icon {
    stroke: #ff00a4;
  }

  .event.active .map-icon {
    stroke: #000;
    stroke-width: 3px;
  }

  .event.click .click-icon {
    visibility: visible;
  }

  .event.d-click .d-click-icon {
    visibility: visible;
  }

  .d-click-icon circle:last-child {
    fill: #0073ff;
  }

  .passed .d-click-icon circle:last-child {
    fill: #ff00a4;
  }

  .active .d-click-icon circle:last-child {
    fill: #000;
    stroke-width: 2px;
  }

  .event.drag-start .drag-start-icon {
    visibility: visible;
  }

  .event.drag-end .drag-end-icon {
    visibility: visible;
    stroke-miterlimit: 10;
  }

  .event.key .key-icon {
    visibility: visible;
  }

  .event.end .start-icon,
  .event.scroll-start .start-icon {
    visibility: visible;
  }

  .event.start .end-icon,
  .event.scroll-end .end-icon {
    visibility: visible;
  }

  .map-icon text {
    fill: #000;
    stroke: none;
    font-size: 8px;
  }
}
</style>
